import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class ComponentRefreshService {
  // Create subjects for each component type
  private paymentsReportRefreshSource = new Subject<void>();
  private enrollmentsListRefreshSource = new Subject<void>();
  private packageListRefreshSource = new Subject<void>();
  private calendarRefreshSource = new Subject<void>();
  private genericRefreshSource = new Subject<string>();

  // Observable streams that components can subscribe to
  paymentsReportRefresh$ = this.paymentsReportRefreshSource.asObservable();
  enrollmentsListRefresh$ = this.enrollmentsListRefreshSource.asObservable();
  packageListRefresh$ = this.packageListRefreshSource.asObservable();
  calendarRefresh$ = this.calendarRefreshSource.asObservable();
  genericRefresh$ = this.genericRefreshSource.asObservable();

  constructor() {
    // Listen for custom refresh events
    document.addEventListener('amt-refresh-data', (event: any) => {
      const componentName = event.detail?.componentName;
      LoggerService.log(`ComponentRefreshService: Received refresh event for ${componentName}`);

      if (componentName) {
        this.refreshComponent(componentName);
      }
    });
  }

  /**
   * Refreshes a component by name
   * @param componentName The name of the component to refresh
   */
  refreshComponent(componentName: string): void {
    LoggerService.log(`ComponentRefreshService: Refreshing ${componentName}`);

    switch (componentName) {
      case 'PaymentsReportViewComponent':
        this.refreshPaymentsReport();
        break;
      case 'EnrollmentsListComponent':
        this.refreshEnrollmentsList();
        break;
      case 'PackageListComponent':
        this.refreshPackageList();
        break;
      case 'DayViewComponent':
      case 'NewWeekViewComponent':
        this.refreshCalendar();
        break;
      default:
        this.genericRefreshSource.next(componentName);
        break;
    }
  }

  /**
   * Refreshes the payments report component
   */
  refreshPaymentsReport(): void {
    LoggerService.log('ComponentRefreshService: Refreshing payments report');
    this.paymentsReportRefreshSource.next();
  }

  /**
   * Refreshes the enrollments list component
   */
  refreshEnrollmentsList(): void {
    LoggerService.log('ComponentRefreshService: Refreshing enrollments list');
    this.enrollmentsListRefreshSource.next();
  }

  /**
   * Refreshes the package list component
   */
  refreshPackageList(): void {
    LoggerService.log('ComponentRefreshService: Refreshing package list');
    this.packageListRefreshSource.next();
  }

  /**
   * Refreshes the calendar/day-view component
   */
  refreshCalendar(): void {
    LoggerService.log('ComponentRefreshService: Refreshing calendar');
    this.calendarRefreshSource.next();
  }
}
